import { AxiosResponse } from 'axios';
import { FiConfiguration } from './FiConfiguration';
import { ProductMapping } from '../productmapping/ProductMapping';
import VersionedResource from '../VersionedResource';

export default class FiConfigurationResource extends VersionedResource {
  public async getFiConfiguration(fiId: number):
    Promise<FiConfiguration> {
    const url = `/api/rcx/config/${fiId}/fi-configuration`;

    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if this is an fi that has not yet been set up, so return an empty configuration
      if (error.response.status !== 404) {
        throw error;
      } else {
        return {
          ascadProcessingEnabled: false,
          rewardsProcessingEnabled: false,
          requireIbLoginOnlyOnLastProcessingDay: false,
          linkedAccountMethodology: 'DIRECT_DEPOSIT_FILE',
          sendFilesDirectToCore: false,
          postingFilesInDatedFolder: false,
          postingFileDateFormat: null,
          fiReportFileFormat: 'TXT',
          earliestReloadDate: null,
          coreFileDeliveryTime: null,
          ibLoginFileDeliveryTime: null,
          unmappedStatusCodeMonitoring: false,
          endOfCyclePostingFilesAutomated: false,
          secondDaySweepFilesAutomated: false,
          automatedFileDeliveryTime: null,
          endOfCycleEmailsAutomated: false,
          endOfCycleEmailDeliveryTime: null,
          deliveryDayOffset: 0,
          loanStatusProcessingEnabled: false,
          fidilAccountProcessingEnabled: false,
          firstLoansCoreProcessingDate: null,
        };
      }
    }
  }

  public async getProductMapping(fiId: number):
    Promise<ProductMapping[]> {
    const url = `/api/rcx/config/${fiId}/product-mapping`;
    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }

  public async updateProduct(fiId: number, pId: number, data: ProductMapping):
    Promise<FiConfiguration> {
    const url = `/api/rcx/config/${fiId}/product-mapping/${pId}`;
    const response: AxiosResponse = await this.apiClient.put(url, data);
    return response.data.data;
  }

  public async updateFiConfiguration(fiId: number, data: FiConfiguration):
    Promise<FiConfiguration> {
    const url = `/api/rcx/config/${fiId}/fi-configuration`;
    const response: AxiosResponse = await this.apiClient.put(url, data);
    return response.data.data;
  }
}
